import { defineAction } from '~/prix'
import citizenPropagateGeoAction from './citizenPropagateGeo.action.json' with { type: 'json' }
import { z } from 'zod'

const citizenPropagateGeoDefinition = defineAction({
  ...citizenPropagateGeoAction,

  input: z.object({
    citizenIds: z.array(z.string()).optional().describe('IDs específicos de cidadãos para propagar (opcional)'),
    clientId: z.number().optional().describe('Client ID para filtrar cidadãos (opcional)'),
    debug: z.boolean().optional().describe('Modo debug com logs detalhados'),
  }),

  output: z.object({
    eligibleCount: z.number().describe('Número de cidadãos elegíveis no preflight'),
    propagatedCount: z.number().describe('Número de cidadãos processados'),
    unchangedCount: z.number().describe('Número de cidadãos já sincronizados sem nova escrita'),
    errors: z.array(z.string()).describe('Lista de erros encontrados'),
  }),
})

export default citizenPropagateGeoDefinition
